import { axiosClient } from "@/lib/axios";
import { HttpError } from "@/types/error";
import { PublicReportingBaseAnalytics } from "@classview/shared-types";
import { UseQueryOptions, useQuery } from "@tanstack/react-query";

export const getReplayBaseAnalytics = async (
  organisationId?: string,
): Promise<PublicReportingBaseAnalytics> => {
  const response = await axiosClient.get(`/analytics/replay-base`, {
    params: { organisationId },
  });
  return response.data;
};

export function getReplayBaseAnalyticsQueryKey(organisationId?: string) {
  return ["replay-base-analytics", organisationId ?? "all-organisations"];
}

export function useGetReplayBaseAnalytics(
  organisationId?: string,
  queryOptions?: Partial<
    UseQueryOptions<PublicReportingBaseAnalytics, HttpError>
  >,
) {
  return useQuery({
    queryKey: getReplayBaseAnalyticsQueryKey(organisationId),
    queryFn: () => getReplayBaseAnalytics(organisationId),
    ...queryOptions,
  });
}
